import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { FaFile } from 'react-icons/fa';
import { useAuth } from '../../../Auth/AuthContext';

export default function DiagnosticoUbicacion(){
    const navigate = useNavigate();
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datosUbicacion, setDatosUbicacion] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/caracterizacion/diagnosticos/listardatosubicacion?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosUbicacion(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtencionesPersonas (row, verAtencionesPersona){
        return (<button id={row.per_idpersona} type="button" onClick={() => verAtencionesPersona(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver atenciones de la persona"
                        aria-label="Ver atenciones de la persona">
                        <FaFile/>
                </button>
        );
    }
    const columns = [
        {
            name: 'Acciones',
            cell: row => verAtencionesPersonas(row, verAtencionesPersona),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Identificación Cabeza', selector: row => row.idpersona, sortable: true, width:'5%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '6%'},
        { name: 'Barrio', selector: row => row.barrio, sortable: true, width: '4%' },
        { name: '¿El Hogar vive o se ubica en un Asentamiento?', selector: row => row.vive_asentamiento, sortable: true, width: '5%' },
        { name: 'Nombre del Asentamiento?', selector: row => row.asentamiento, sortable: true, width: '5%' },
        { name: 'Teléfonos', selector: row => row.telefonos, sortable: true, width: '5%' },
        { name: 'Dirección', selector: row => row.cab_direccion, sortable: true, width: '5%' },
        { name: 'Tipo Vivienda', selector: row => row.tip_tipovivienda, sortable: true, width: '4%' },
        { name: 'Forma de Tenencia', selector: row => row.tip_tenencia, sortable: true, width: '4%' },
        { name: 'Retono y Reubicación', selector: row => row.for_forma, sortable: true, width: '4%' },
        { name: 'Fecha de Retono y Reubicación Año', selector: row => row.cab_anyollegadaret, sortable: true, width: '5%' },
        { name: 'Fecha de Retono y Reubicación Mes', selector: row => row.cab_mesllegadaret, sortable: true, width: '5%' },
        { name: 'El hogar desea', selector: row => row.des_deseo, sortable: true, width: '3%' },
        { name: '¿Porqué eligió venirse para Medellín?', selector: row => row.porquemedellin, sortable: true, width: '3%' },
        { name: '¿El Hogar desea?', selector: row => row.tip_tipoexpectativaubi, sortable: true, width: '3%' },
        { name: 'MUNICIPIO donde desea reubicarse', selector: row => row.mun_municipio, sortable: true, width: '3%' },
        { name: '¿A qué lugar exacto?', selector: row => row.tip_tipolugar, sortable: true, width: '3%' },
        { name: 'Nombre del barrio o de la vereda o del corregimiento', selector: row => row.cab_nombreentorno, sortable: true, width: '5%' },
        { name: '¿Por qué?', selector: row => row.cab_porqueubicacion, sortable: true, width: '5%' }
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatosubicacion?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_ubicacion.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico ubicaci&oacute;n</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/consultas/verdiagnosticos" >Diagn&oacute;sticos</NavLink></li>
                        <li className="breadcrumb-item active"> Ubicaci&oacute;n</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos />
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosUbicacion} titulo={'Informe Datos Ubicacion'} exportarCSV={exportarCSV} />
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Ubicacion"
                                    columns={columns}
                                    data={datosUbicacion}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}